import { pushToDataLayer, DataLayerEvent } from 'components/helpers/Global/Analytics/DataLayer';

export interface CtaContentResultAnalyticsConfig {
  contentListName?: string;
}

export const pushCtaContentResultEvent = ({
  contentListName,
  linkUrl,
}: {
  contentListName?: string;
  linkUrl?: string;
}) => {
  const normalizedContentListName = contentListName?.trim();

  if (!normalizedContentListName) {
    return;
  }

  const payload: DataLayerEvent = {
    event: 'content_result',
    content_list_name: normalizedContentListName,
    link_url: linkUrl || '',
  };

  pushToDataLayer(payload);
};
